<template>

    <section
        id="schedule"
        class="schedule"
    >

        <div class="schedule__container">

            <div class="schedule__card">

                <article
                    v-for="(item, index) in scheduleItems"
                    :key="index"
                    class="schedule__item"
                >

                    <div class="schedule__icon">
                        <i :class="item.icon"></i>
                    </div>

                    <div class="schedule__content">

                        <h3>
                            {{ item.hash | staticTitle }}
                        </h3>

                        <span v-if="item.timeHash">
                            {{ item.timeHash | staticTitle }}
                        </span>

                        <p>
                            {{ item.hash | staticContent }}
                        </p>

                    </div>

                </article>

            </div>

        </div>

    </section>

</template>

<script>
export default {
    name: 'HomeSchedule',

    data() {
        return {
            scheduleItems: [
                {
                    hash: 'schedule_sunday',
                    timeHash: 'schedule_sunday_time',
                    icon: 'fa-regular fa-calendar-days'
                },
                {
                    hash: 'schedule_bible_study',
                    timeHash: 'schedule_bible_study_time',
                    icon: 'fa-solid fa-book-open'
                },
                {
                    hash: 'schedule_welcome',
                    timeHash: null,
                    icon: 'fa-solid fa-users'
                }
            ]
        };
    }
};
</script>

<style lang="scss" scoped>
.schedule {
    position: relative;

    padding: 0 20px 15px;

    background: var(--background);

    &__container {
        position: relative;

        width: 100%;
        max-width: 1425px;

        margin: 0 auto;

        transform: translateY(-65px);

        z-index: 10;
    }

    &__card {
        display: grid;
        grid-template-columns: 1fr;

        background: var(--white);

        border-radius: 4px;

        box-shadow: 0 25px 50px rgba(0, 0, 0, .10);

        overflow: hidden;
    }

    &__item {
        min-height: 170px;

        display: flex;
        align-items: center;

        gap: 28px;

        padding: 28px 34px;

        border-bottom: 1px solid var(--gray-200);
    }

    &__icon {
        width: 46px;

        flex: 0 0 46px;

        display: flex;
        align-items: center;
        justify-content: center;

        color: var(--primary);

        font-size: 38px;

        line-height: 1;
    }

    &__content {

        h3 {
            margin: 0 0 6px;

            color: var(--text);

            font-size: 16px;
            font-weight: 700;

            line-height: 1.25;

            text-transform: uppercase;
        }

        span {
            display: block;

            margin-bottom: 12px;

            color: var(--primary);

            font-size: 14px;
            font-weight: 700;

            line-height: 1.2;
        }

        p {
            max-width: 260px;

            margin: 0;

            color: var(--text);

            font-size: 14px;

            line-height: 1.55;
        }
    }
}

@media (min-width: 768px) {
    .schedule {
        padding: 0 28px 10px;

        &__container {
            transform: translateY(-65px);
        }

        &__card {
            grid-template-columns: repeat(3, 1fr);
        }

        &__item {
            min-height: 170px;

            padding: 28px 32px;

            border-bottom: none;
            border-right: 1px solid var(--gray-200);

            &:last-child {
                border-right: none;
            }
        }
    }
}

@media (min-width: 1024px) {
    .schedule {

        &__container {
            transform: translateY(-65px);
        }

        &__item {
            padding: 30px 46px;
        }

        &__icon {
            width: 48px;

            flex-basis: 48px;

            font-size: 40px;
        }
    }
}

@media (min-width: 1320px) {
    .schedule {

        &__item {
            padding: 30px 54px;
        }
    }
}
</style>